export default __webpack_public_path__ + "static/media/a1.492d4464.png";